import React from "react";
import { UsersMap } from "../../types";

export interface ISlackContext {
	usersMap: UsersMap;
}

const SlackContext = React.createContext({ usersMap: {} } as ISlackContext);

export default SlackContext;